import React from 'react';
import CoursePageTemplate from './components/CoursePageTemplate';

function PetrofNepo() {
  return (
    <CoursePageTemplate
      courseId="petrof-do-nepo"
    />
  );
}

export default PetrofNepo;
